import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RemoteEmeaIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M4.9375 12.1854C4.9375 14.2193 4.9375 17.3934 4.9375 17.3934C11.3683 17.3934 9.77592 17.3934 15.405 17.3934V12.1854",
                fill: "#FF642E"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.9375 12.1854V17.3934C11.3683 17.3934 9.77592 17.3934 15.405 17.3934V12.1854L10.1712 7.33423L4.9375 12.1854Z",
                fill: "#FF642E"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.9375 12.1854C4.9375 14.2193 4.9375 17.3934 4.9375 17.3934M4.9375 12.1854L10.1712 7.33423L15.405 12.1854V17.3934C9.77592 17.3934 11.3683 17.3934 4.9375 17.3934M4.9375 12.1854V17.3934",
                stroke: "#FF642E",
                strokeWidth: "1.90547",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.6001 5.98158C10.3573 5.75936 9.98503 5.75936 9.74228 5.98158L3.73449 11.4815C3.31413 11.8663 2.65985 11.8392 2.27312 11.4209C1.88638 11.0026 1.91365 10.3516 2.33401 9.96675L8.78476 4.06129C8.96532 3.8861 9.17781 3.74667 9.41093 3.65054C9.65195 3.55115 9.91028 3.5 10.1712 3.5C10.4321 3.5 10.6904 3.55115 10.9314 3.65054C11.1645 3.74667 11.377 3.88609 11.5576 4.06128L18.0083 9.96675C18.4287 10.3516 18.456 11.0026 18.0692 11.4209C17.6825 11.8392 17.0282 11.8663 16.6078 11.4815L10.6001 5.98158Z",
                fill: "#FF642E"
            })
        ]
    });
